import {createSlice, PayloadAction} from '@reduxjs/toolkit'

interface DashboardState {
    deposit: boolean;
    withdraws: boolean;
    linear: boolean;
    sales: boolean;
}

const initialDashboardState: DashboardState = {
    deposit: true,
    withdraws: true,
    linear: true,
    sales: true
};

export const dahsboardSlide = createSlice({
    name: 'dashboard',
    initialState: initialDashboardState,
    reducers: {
        setDepositLoading: (state, action: PayloadAction<boolean>) => {
            state.deposit = action.payload;
        },
        setWithdrawLoading: (state, action: PayloadAction<boolean>) => {
            state.withdraws = action.payload;
        },
        setLinearLoading: (state, action: PayloadAction<boolean>) => {
            state.linear = action.payload;
        },
        setSalesLoading: (state, action: PayloadAction<boolean>) => {
            state.sales = action.payload;
        }
    }
})

export const {setDepositLoading, setSalesLoading, setWithdrawLoading, setLinearLoading} = dahsboardSlide.actions
export default dahsboardSlide.reducer
